import React, { useState } from 'react';
import {
  Text,
  Stack,
  Flex,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  Input,
  Button,
  Textarea,
  Box,
} from '@chakra-ui/react';
import BrandButton from '../brandButton/BrandButton';
import { AiFillCustomerService, AiFillWarning } from 'react-icons/ai';
import { mutateFunction, useMutation } from '../../libs/apis';
import { CustomToast } from '../toast/CustomToast';
import CreateComment from '../feed/CreateComment';

export default function GenericModal({
  isOpen,
  onClose,
  children
}) {
  if (!isOpen) return null;

  return (
    <div>
      <Modal isOpen={isOpen} onClose={onClose} size="xl">
        <ModalOverlay />
        <ModalContent style={{backgroundColor: "transparent"}}>
          <ModalBody className='bg-transparent'>
            <Box className="w-full flex flex-col items-center justify-center">
              {children}
            </Box>
          </ModalBody>
        </ModalContent>
      </Modal>
    </div>
  );
}
